import React from "react";
import { Link, useLocation } from "react-router-dom";

import "./Sidebar.css";
import { red } from "@material-ui/core/colors";
function Sidebar({ Userrouting }) {
  let currentLocation = useLocation(); //*
  console.log(Userrouting, "Userrouting"); // call and console//
  return (
    <nav className="sidebar sidebar-offcanvas" id="sidebar">
      <ul className="nav nav-pills flex-column mb-auto">
        {Userrouting.map((e, i) => (
          <li
            key={i}
            className={
              currentLocation.pathname == e.path
                ? "nav-item active"
                : "nav-item"
            }
          >
            <Link className="nav-link" to={e.path}>
              <i className={e.icon}></i>&nbsp;&nbsp;
              <span className="menu-title">{e.name}</span>
            </Link>
          </li>
        ))}
      </ul>
    </nav>

    // <Sidebar1
    //   collapsed={false}
    //   backgroundColor={"black"}
    //   className=""
    //   transitionDuration={500}
    //   width={"230px"}
    // >
    //   <Menu>
    //     {Userrouting.map((e, i) => (
    //       <MenuItem
    //         className={
    //           currentLocation.pathname === e.path
    //             ? "nav-item active"
    //             : "nav-item"
    //         }
    //         key={i} // Make sure to add a unique key prop to each MenuItem
    //       >
    //         <Link className="nav-link" to={e.path}>
    //           <i className={`${e.icon} custom-icon`}></i>
    //           <span className="menu-title">{e.name}</span>
    //         </Link>
    //       </MenuItem>
    //     ))}
    //   </Menu>
    // </Sidebar1>
  );
}

export default Sidebar;
